module.exports = __webpack_public_path__ + "static/media/ilha_2.2e4ff66f.jpg";